import React from 'react'
import UserAvatar from './UserAvatar'
import AttachmentItem from './AttachmentItem'
import { Message, Attachment } from '../../types/messages'
import { formatDate } from '../../utils/formatHelpers'

interface MessageItemProps {
  message: Message
  currentUserId: number | null
  onDownloadAttachment: (attachment: Attachment) => void
}

const MessageItem = ({ message, currentUserId, onDownloadAttachment }: MessageItemProps) => {
  const isCurrentUser = message.senderId === currentUserId

  return (
    <div
      className={`tw-flex tw-w-full ${isCurrentUser ? 'tw-justify-end' : 'tw-justify-start'}`}
    >
      <div className={`
          tw-flex tw-gap-x-2 md:tw-gap-x-2.5 tw-items-end 
          tw-min-w-0 /* <--- KLUCZOWA ZMIANA TUTAJ */
          ${isCurrentUser ? 'tw-flex-row-reverse' : 'tw-flex-row'}
        `}
      >
        <div className='tw-flex-shrink-0'>
          {(!isCurrentUser) && (
            <UserAvatar
              name={message.senderName}
              size={32}
              id={message.senderId}
            />
          )}
        </div>

        <div
          className={`
            tw-px-3.5 tw-py-2 tw-shadow-sm
            tw-max-w-[85%] xs:tw-max-w-[80%] sm:tw-max-w-[70%] md:tw-max-w-md lg:tw-max-w-lg xl:tw-max-w-xl 
            tw-min-w-0 /* To również jest ważne dla samego dymka jako elementu flex */
            ${isCurrentUser
                  ? 'tw-bg-green-600 tw-text-white tw-rounded-t-xl tw-rounded-l-xl tw-rounded-br-sm'
                  : 'tw-bg-slate-100 dark:tw-bg-slate-700 tw-text-slate-800 dark:tw-text-slate-100 tw-rounded-t-xl tw-rounded-r-xl tw-rounded-bl-sm'
              }
          `}
        >
          {message.content && (
            <p className={`
              tw-text-sm tw-leading-relaxed tw-whitespace-pre-wrap tw-break-words 
              ${((message.attachments != null) && message.attachments.length > 0) || (message.timestamp) ? 'tw-mb-1.5' : 'tw-mb-0'}
            `}
            >
              {message.content}
            </p>
          )}

          {(message.attachments != null) && message.attachments.length > 0 && (
            <div className={`tw-mt-1.5 ${message.content ? 'tw-pt-1.5 tw-border-t' : ''} ${isCurrentUser ? 'tw-border-sky-500/50' : 'tw-border-slate-300/70 dark:tw-border-slate-600/70'}`}>
              <div className='tw-space-y-1.5'>
                {message.attachments.map((attachment) => (
                  <AttachmentItem
                    key={attachment.id || attachment.name}
                    attachment={attachment}
                    onDownload={onDownloadAttachment}
                    isDarkBackground={isCurrentUser}
                  />
                ))}
              </div>
            </div>
          )}

          <small
            className={`tw-block tw-text-xs tw-mt-1.5 tw-opacity-80 ${isCurrentUser ? 'tw-text-green-100' : 'tw-text-slate-500 dark:tw-text-slate-400'}`}
          >
            {formatDate(message.timestamp)}
          </small>
        </div>
      </div>
    </div>
  )
}

export default MessageItem
